// extracted by mini-css-extract-plugin
export var bodyRow = "_dd-d";
export var cardColumns = "_dd-e";
export var ellipsesOverflow = "_dd-2";
export var flatBottomCorners = "_dd-3";
export var flatTopCorners = "_dd-4";
export var headerActionsDropdown = "_dd-f";
export var headerBottomRow = "_dd-c";
export var headerTopRow = "_dd-b";
export var orderDetailsWrapper = "_dd-0";
export var orderInfoContainer = "_dd-1";
export var productDetails = "_dd-9";
export var productImage = "_dd-5";
export var responsiveTable = "_dd-8";
export var shipmentContainer = "_dd-a";
export var tableBottomLeft = "_dd-6";
export var tableBottomRight = "_dd-7";
export var trackingLink = "_dd-g";